export const EoLTKey = {
  PRODUCT_ID: 'productId',
  FACILITY: 'facility',
  data: 'data',
  QUANTITY_SOLD: 'totalProductSold',
  disposalMethodData: 'disposalMethodData',
  disposalKey: {
    landfill: 'landfill',
    incineration: 'incineration',
    recycling: 'recycling',
    reclaimed: 'reclaimed',
    notTreated: 'notTreated',
    reused: 'reused'
  },
  disposalMethod: 'disposalMethod',
  treated: {
    productTreated: 'weightOfProductTreated',
    treatmentCost: 'treatmentCost'
  },
  notTreated: {
    ProductNotTreated: 'weightOfProductNotTreated'
  },
  PRODUCT_TYPE: 'productType',
  FACILITIES: 'facilities',
  FACILITY_ID: 'facilityId'
};

export const EoLTLabel = {
  PRODUCT_ID: 'Product Name',
  FACILITY: 'Facility',
  wasteType: 'Waste Type',
  data: 'data',
  QUANTITY_SOLD: 'Quantity of product sold',
  disposalMethodData: 'No. Disposal Method',
  disposalKey: {
    landfill: 'Landfill',
    incineration: 'Incineration',
    recycling: 'Recycling',
    reclaimed: 'Reclaimed',
    notTreated: 'Not Treated',
    reused: 'Reused'
  },
  treated: {
    productTreated: 'Weight of product treated',
    treatmentCost: 'Treatment Cost'
  },
  notTreated: {
    ProductNotTreated: 'Weight of product not treated'
  }
};
